import React from 'react';
import { connect } from 'react-redux';
import { MainComponentBox } from '@/util/util.jsx';
import { Row, Col, Panel } from 'react-bootstrap';
import { Map, List, fromJS, OrderedMap } from 'immutable';
import RegNumberElement from '../elements/RegNumberElement';
import { getDealListWrapper } from '../store/DealsWrapper';
import { UrlSimpleWrappedSpan } from '@/util/util';
import { getTransportIcon } from '../transport/SmallTransportDisplay';
import { formTransportName } from '../elements/TransportElement';
import {
  REF_PATH as SUPPLIER_REF_PATH,
  REF_NAME as SUPPLIER_REF_NAME } from '@/component/dict/simple/supplier/Const';
import {
  REF_PATH as BUYER_REF_PATH,
  REF_NAME as BUYER_REF_NAME } from '@/component/dict/simple/buyer/Const';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper.js';
import ProductInPackingDisplayWrapper from
  '@/component/dict/complex/product/ProductInPackingDisplayWrapper';

class GlobalSearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.formDealsList = this.formDealsList.bind(this);
    this.formResultsList = this.formResultsList.bind(this);
    this.getProductName = this.getProductName.bind(this);
  }
  componentWillMount() {
    getDealListWrapper('purchase');
    getDealListWrapper('sale');
    getDealListWrapper('transport');
    getSimpleListWrapper(BUYER_REF_NAME, BUYER_REF_PATH);
    getSimpleListWrapper(SUPPLIER_REF_NAME, SUPPLIER_REF_PATH);
  }
  shouldComponentUpdate(props) {
    return !(!props.dealList.get('purchase')
    || !props.dealList.get('sale')
    || !props.dealList.get('transport')
    || !props.supplierList
    || !props.buyerList);
  }

  getProductName(deal) {
    const items = deal.get('products', new List());
    let uniqueItems = new Map();
    items.forEach(product => {
      const productId = product.get('product');
      const productTypeId = product.get('productType');
      uniqueItems = uniqueItems.set(`${productId}${productTypeId}`, [productId, productTypeId]);
    });
    let uniqueProducts = new List();
    uniqueItems.forEach(item => {
      const productId = item[0];
      const productTypeId = item[1];
      uniqueProducts = uniqueProducts.push(items.
        find(product => product.get('product') === productId
          && product.get('productType') === productTypeId));
    });
    uniqueProducts = uniqueProducts.map(product => {
      if (product.get('product') == null) {
        return null;
      }
      return (<span>
        <ProductInPackingDisplayWrapper
          productTypeId={product.get('productType')}
          noBorder
        />
      </span>);
    });
    return uniqueProducts.reduce((total, comp) => {
      if (comp == null) {
        return total;
      }
      if (total.size == 0) {
        return total.push(comp);
      }
      return total.push(', ').push(comp);
    }, new List());
  }

  formDealsList(dealType, ids, keyResult) {
    if (!dealType || !ids || ids.size == 0) {
      return <div />;
    }
    let result = <div />;
    const deals = ids.map(id => this.props.dealList.get(dealType.toLowerCase(), new List())
      .find(d => d.get('id') == id)).filter(d => d);
    switch (dealType.toLowerCase()) {
      case 'purchase':
      case 'sale':
        result = deals.map((deal, idx) =>
          <Row key={idx}>
            <Col xs={12}>
              <UrlSimpleWrappedSpan url={`/deals/${dealType.toLowerCase()}/${deal.get('id')}`}>
                <RegNumberElement
                  inline data={deal}
                  className="search-row-ps"
                  type={dealType.toLowerCase()}
                />
                  &nbsp;&nbsp;
                {this.getProductName(deal, keyResult)}
              </UrlSimpleWrappedSpan>
            </Col>
          </Row>
        );
        break;
      case 'transport':
        result = deals.filter(d => d.get('transportType') == 'BULK')
          .concat(deals.filter(d => d.get('transportType') == 'CONTAINER'))
          .concat(deals.filter(d => d.get('transportType') == 'RAILCAR'))
          .concat(deals.filter(d => d.get('transportType') == 'TRUCK'))
          .map((deal, idx) => {
            const icon = getTransportIcon(deal.get('transportType', '').toLowerCase());
            return (<Row key={idx}>
              <Col xs={12}>
                <UrlSimpleWrappedSpan
                  className="search-row-transport"
                  url={`/deals/${dealType.toLowerCase()}/${deal.get('id')}`}
                >
                  {icon}&nbsp;&nbsp;{formTransportName(deal)}
                  &nbsp;&nbsp;
                  {this.getProductName(deal, keyResult)}
                </UrlSimpleWrappedSpan>
              </Col>
            </Row>);
          });
        break;
      default:
    }
    return result;
  }
  formResultsList(keyResult, values) {
    if (!values || values.size == 0) {
      return <div />;
    }
    return values.map((value, key, idx) => <Row key={idx}>
      <Col xs={12}>
        {this.formDealsList(key, fromJS(value), keyResult)}
      </Col>
    </Row>);
  }
  render() {
    return (<MainComponentBox>
      <Row className={'report-panel'}>
        <Col xs={12}>
          {this.props.searching
          || !this.props.dealList.get('purchase')
          || !this.props.dealList.get('sale')
          || !this.props.dealList.get('transport')
          || !this.props.supplierList
          || !this.props.buyerList ?
            <div className="searching">Searching</div> :
            <div className="search-results">
              <div className="search-results-label">{this.props.searchText ?
                `Search results for '${this.props.searchText}'` : ''}</div>
              {this.props.results.map((value, key) => {
              // eslint-disable-next-line
              const immutableValue = value ? OrderedMap(value) : value;
                const resultsCount = value ? Object.values(value).flatten().length : 0;
                return (<Row key={key}>
                  <Col xs={12}>
                    {immutableValue && immutableValue.size > 0 ?
                      <Panel collapsible defaultExpanded header={`${key} (${resultsCount})`}>
                        {this.formResultsList(key, immutableValue)}
                      </Panel>
                      : <div />}
                  </Col>
                </Row>);
              })}
            </div>
          }
        </Col>
      </Row>

    </MainComponentBox>);
  }
}
GlobalSearchResults.propTypes = {
  searching: React.PropTypes.bool,
  results: React.PropTypes.object,
  dealList: React.PropTypes.object,
  supplierList: React.PropTypes.object,
  buyerList: React.PropTypes.object,
  searchText: React.PropTypes.string,
};
export default connect(state => ({
  dealList: state.getIn(['data', 'deals', 'list'], new Map()),
  searching: state.getIn(['allaround', 'globalSearchInProgress']),
  searchText: state.getIn(['allaround', 'globalSearchText'], ''),
  results: state.getIn(['search', 'globalsearch'], new OrderedMap()),
  supplierList: state.getIn(['references', 'simple', SUPPLIER_REF_PATH]),
  buyerList: state.getIn(['references', 'simple', BUYER_REF_PATH]),
}))(GlobalSearchResults);
